export const API_BASE_URL = process.env.FITX_APP_API_URL;
export const MONITOR_API_BASE_URL = process.env.FITX_MONITOR_API_URL;
